export enum ScheduleGenerateTypes {
  Auto = 1,
  Manual = 2
}
